import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, OTO_STORE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

import { HeaderCartButton } from './OTOStore';

const OTOStoreMyOrders = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true,
				showOnMap: true,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES_USED,
				width: 100,
				renderCell: ListComponents.DC_LOGO
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string,
				width: 100,
				renderCell: ListComponents.TRACKING_URL
			},
			{
				Header: 'trackingURL',
				accessor: 'trackingURL',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'deliveryDate',
				accessor: 'deliveryDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				showOnMobile: true
			},
			{
				Header: 'address',
				accessor: 'address',
				width: 140,
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'customer',
				accessor: 'name',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'quantity',
				accessor: 'packageCount',
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				Header: 'grandTotal',
				accessor: 'grandTotal',
				renderCell: ListComponents.CURRENCY,
				filterType: FilterType.float,
				showOnMobile: true
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.SHIPMENT_STATUS,
				statusHistoryApi: OTO_STORE.GET_ORDER_STATUSES_BY_ID,
				width: 200,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader boldTitle="myOrders" lightTitle="otoStore" icon={faArrowLeft} backUrl={PATHS.OTO_STORE} />
				<HeaderCartButton />
			</HeaderContainerFormHeader>
			<DynamicList
				id={DYNAMICLISTS.OTO_STORE_MY_ORDERS}
				columns={columns}
				fetchUrl={OTO_STORE.GET_ORDERS}
				exportName="myOrders"
				defaultSort={[{ id: 'orderID', desc: true }]}
				actionObjectType={ACTION_OBJECT_TYPES.ORDER}
			/>
		</div>
	);
};

export default OTOStoreMyOrders;
